"use client";
import Image from "next/image";
import Logo from "@/assets/images/login-hero.png";
import LogoLogin from "@/assets/images/logo-login.png";
import { useRouter } from "next/navigation";

interface LayoutAdminProps {
  children: React.ReactNode;
}

const LayoutAuth = (props: LayoutAdminProps) => {
  const router = useRouter();
  const gotoHome = () => {
    router.push("/");
  };
  return (
    <div>
      <section className="flex flex-col h-screen">
        <div className="bg-primary md:bg-slate-50 grid flex-1 grid-cols-1 md:grid-cols-[50%_minmax(50%,_1fr)]">
          {/* LEFT */}
          <div className="right px-14 hidden h-full bg-white md:flex flex-col gap-5 justify-center items-center">
            <div onClick={gotoHome} className="cursor-pointer">
              <Image
                src={LogoLogin}
                alt="logo"
                width={500}
                height={500}
                unoptimized
                className="w-[110px] object-contain"
              />
            </div>
            <div className="flex flex-col gap-2">
              <div className="font-semibold text-primary-700 text-3xl">
                Bersama Wujudkan{" "}
                <span className="text-secondary-400">Perubahan Nyata</span>
              </div>
              <div className="text-[#473D3D]">
                RESES menjadi jembatan aspirasi antara masyarakat dan pemangku
                kebijakan. Bersama, kita dengar, tindak lanjuti, dan wujudkan
                perubahan nyata demi kemajuan bersama.
              </div>
            </div>
            <div className="im h-[370px] overflow-hidden mt-4">
              <Image
                src={Logo}
                alt="logo"
                width={400}
                height={400}
                unoptimized
                className="w-fit h-full object-contain"
              />
            </div>
          </div>
          {/* RIGHT */}
          <div className="left px-4 md:mx-0 w-full bg-[url('/assets/images/bg-forgot-password.png')] bg-repeat bg-cover flex flex-col justify-center items-center">
            <div className="card w-full rounded-lg md:mt-0 sm:max-w-2xl mx-3 xl:p-0 ">
              <div className="p-6 sm:p-8">
                <div className="space-y-1 mb-10">
                  <div className="text-white font-semibold text-3xl">
                    Selamat Datang di SIMRESES <br />
                    DPRD KAB PALI
                  </div>
                </div>
                {props.children}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LayoutAuth;
